// @flow

import React, { Component } from 'react';

import './RadioButtonGroup.css';

class RadioButtonGroup extends Component {
  state: { currentValue: string };
  onChange: Function;
  renderChildren: Function;

  constructor(props: Object) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.renderChildren = this.renderChildren.bind(this);
    this.state = { currentValue: props.value };
  }

  onChange(event: Object) {
    this.setState({
      currentValue: event.currentTarget.value,
    });

    this.props.onFilterChange({
      filterName: this.props.filterName,
      enabled: this.props.enabled,
      value: event.currentTarget.value,
    });
  }

  renderChildren() {
    return React.Children.map(this.props.children, (child, index) => {
      const { filterName } = this.props;
      const id = filterName + index;
      const checked = child.props.value === this.state.currentValue;
      return React.cloneElement(child, {
        checked,
        id,
        filterName,
        onChange: this.onChange,
      });
    });
  }

  render() {
    const { enabled, filterName, label, onFilterChange, value } = this.props;

    const onEnabledChange = event => {
      onFilterChange({ filterName, enabled: !enabled, value });
    };

    return (
      <div className="RadioButtonGroup filter">
        <div className="top">
          <label>
            <input
              type="checkbox"
              onChange={onEnabledChange}
              checked={enabled}
            />
            {label}
          </label>
        </div>
        {enabled &&
          <div className="control">
            {this.renderChildren()}
          </div>}
      </div>
    );
  }
}

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/RadioButtons/RadioButtonGroup.js